import store from '../store';
import { updateRouteInfo, getSearchResults,updateSeatChartDet } from '../actions/editPolicy-actions';
import moment from 'moment';

export function fetchGet(url) {
    return fetch(url).then(function(response){
        return response.json();
    }).then(function(data) {
        return data;
    })
}

export function fetchPost(url, postData) {
    let params = new FormData();
    Object.keys(postData).forEach(el => {
        params.append(el, postData[el]);
    });

    return fetch(url, {
        body: params,
        method: 'POST',
        mode: 'cors'
    }).then(function(response){
        return response.json();
    }).then(function(data) {
        return data;
    })
}

export function getRouteInfo(rsid){
    let url = '/api/resource/getRouteInfo?routeID=' + rsid;
    //for app webview pass app agentId in api
    const appAgentId = localStorage.getItem("AgentId");
    if(appAgentId){
        url+='&appAgentId='+appAgentId;
    }

    fetchGet(url)
    .then(data => {
        store.dispatch(updateRouteInfo(data));
    })
    .catch((err) => console.log(err));
}

export function getRoute(rsid){
    let url = '/api/resource/getRouteInfo?routeID=' + rsid;

    //for app webview pass app agentId in api
    const appAgentId = localStorage.getItem("AgentId");
    if(appAgentId){
        url+='&appAgentId='+appAgentId;
    }

    fetchGet(url)
    .then(data => {
        store.dispatch(updateSeatChartDet(rsid, data));
    })
    .catch((err) => console.log(err));
}


export function get24HrPointTime(val) {
    var hhmm = val.split(/[^0-9]/);
    var ampm = val.split(" ");
    var hour;
    
    if(ampm[2] === 'pm' && hhmm[3] < 12){
        hour = parseInt(hhmm[3]) + 12;
    }else if(ampm[2] === 'am' && hhmm[3] === 12){
        hour = '00';
    }else{
        hour = hhmm[3];
    }
    return (hour + ':' + hhmm[4] + ' ');
}

/*function get12hrTime(val) {
    var temp = val.split(/[^0-9]/);
    var dt = new Date (temp[0],temp[1]-1,temp[2],temp[3],temp[4],temp[5] );
    var hrs = dt.getHours() <= 12 ? dt.getHours() : (12 - dt.getHours() > 0 ? 12 - dt.getHours() : dt.getHours() - 12);
    var mins = dt.getMinutes();
    return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins) + (dt.getHours() < 12 ? ' AM': ' PM');
}*/

export function get12hrTime (time) {
    // Check correct time format and split into components
    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) { // If time format correct
    time = time.slice (1); // Remove full string match value
    time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join (''); // return adjusted time or original string
}

export function getDateFormat(val){
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    //let weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

    const split = val.split(' ');
    const dt = new Date(split[0]);
    //const day = weekday[dt.getDay()];
    const dateVal = dt.getDate();
    const month = months[dt.getMonth()];
    const year = (dt.getFullYear() + '');
    //const dts = day + ',' + (dateVal < 10 ? '0' + dateVal : dateVal) + ' ' + month + ',' + year;
    const dts = (dateVal < 10 ? '0' + dateVal : dateVal) + ' ' + month + ', ' + year;
    const timeval = get12hrTime(split[1]);
    return timeval + ' - ' + dts;
}

export function isInteger(num) {
    return (num % 1) === 0;
}

export function getBusDetails(fromCityId,fromCityName,toCityId,toCityName,departDate,mode){
    store.dispatch(getSearchResults([]));
    let url = '/api/resource/searchRoutes?fromCityID=' + fromCityId + '&toCityID=' + toCityId + '&fromCityName=' + fromCityName + '&toCityName=' + toCityName +'&journeyDate=' + getRevDate(departDate)+ '&mode='+ mode;

    //for app webview pass app agentId in api
    const appAgentId = localStorage.getItem("AgentId");
    if(appAgentId){
        url+='&appAgentId='+appAgentId;
    }

    console.log(url);
    fetchGet(url).then(function(data) {
        data = data.sort((a,b) => {return (a.DepartureTime > b.DepartureTime) ? 1 : ((b.DepartureTime > a.DepartureTime) ? -1 : 0)});
        store.dispatch(getSearchResults(data));
    }).catch(function(error) {
        store.dispatch(getSearchResults(false));
        console.log(error);
    });
}

export function getRevDate(val) {
    return val.split('-')[2] + '-' + val.split('-')[1] + '-' + val.split('-')[0];
}

export function get24HrTime(val) {
    // const dt = new Date(val);
    val = val.split(/[^0-9]/);
    const dt = new Date (val[0],val[1]-1,val[2],val[3],val[4],val[5] );
    const hrs = dt.getHours();
    const mins = dt.getMinutes();
    return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins);
}

export function getDur(dep, arr) {
    const diff = (Math.abs(new Date(arr) - new Date(dep))) / (1000 * 60);
    return Math.floor(diff / 60) + 'h ' + (diff % 60) + 'm';
}

export function capitalizeFirstLetter(string) {
    var str = string.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getFormattedDateForURL(dateString) {
    //alert(dateString);
    //dateString = dateString.replace(/-/g, ' '); //firefox doesn't understand hyphens in date
    var d = dateString;
    d = new Date(dateString);
    var day = d.getDate(),
        month = d.getMonth() + 1,
        year = d.getFullYear();

    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;

    return day + "-" + month + "-" + year;
}

export function getDateForm(dateStr){
    var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var date = new Date(dateStr.split("-").reverse().join("-"));
    var newDate = date.getDate();
    var dayName = days[date.getDay()];
    var monthName = months[date.getMonth()];
    var newFormat = dayName+", "+newDate+' '+monthName;
    return newFormat;
}

export function getDateFormString(dateStr){
    var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var date = new Date(dateStr);
    var newDate = date.getDate();
    var dayName = days[date.getDay()];
    var monthName = months[date.getMonth()];
    var newFormat = dayName+", "+newDate+' '+monthName;
    return newFormat;
}

export function getrecheduledate(val){
    const dt = new Date(val);
    const dt1 = val.split('-');
    const month = dt.getMonth()+1;
    return (dt1[2] + '-' + (month < 10 ? '0' + month : month) + '-'+ dt1[0]) ;
}

export const getImgPath = (path) => window.imgPath + path;

export function get24HoursDateTime(val) {
    return moment(val,'YYYY-MM-DD hh:mm a').format("ddd, HH:mm D MMM ");
}

export function getDateFormatIPhone(val, format) {
    if (!val) return ""; // Return empty if input is invalid

    val = String(val).trim(); // Ensure val is a string and remove extra spaces
    let newDate;

    // Detect ISO 8601 format (e.g., "2025-02-28T16:40:00")
    if (val.includes("T")) {
        newDate = new Date(val); // Directly parse ISO dates
    } else {
        let datePart = "1970-01-01", timePart = "00:00:00", meridiem = "";

        let parts = val.split(" ");
        if (parts.length >= 1) datePart = parts[0]; // Date
        if (parts.length >= 2) timePart = parts[1]; // Time
        if (parts.length >= 3) meridiem = parts[2]; // AM/PM

        let [year, month, day] = datePart.split("-").map(n => parseInt(n, 10) || 0);
        let [hour, min, sec] = timePart.split(":").map(n => parseInt(n, 10) || 0);

        // Defaults: If missing, use reasonable defaults
        year = year || new Date().getFullYear();
        month = (month ? month - 1 : 0); // JavaScript months are 0-based
        day = day || 1;
        hour = hour || 0;
        min = min || 0;
        sec = sec || 0;

        // Handle AM/PM conversion
        if (meridiem) {
            meridiem = meridiem.toLowerCase();
            if (meridiem === "pm" && hour !== 12) hour += 12;
            if (meridiem === "am" && hour === 12) hour = 0;
        }

        // Create a valid Date object
        newDate = new Date(year, month, day, hour, min, sec);
    }

    // Format using Moment.js
    return moment(newDate).format(format);
}


// WEBPACK FOOTER //
// ./src/common/common.js